export default __webpack_public_path__ + "static/media/NotoSans-Black.f2e40ede.woff";